import { createFileRoute } from '@tanstack/react-router';

import { AnalyticsMoveReportPage } from '@pages/analytics';
import { ANALYTICS_MOVE_TAB_CERTIFICATIONS } from '@pages/analytics/ui/analytics-move-tabs';
import { Skeleton, Stack } from '@shared/ui';

export const Route = createFileRoute('/$locale/_authenticated/analytics-move/certifications')({
  component: AnalyticsMoveCertificationsRoute,
  pendingComponent: AnalyticsMoveCertificationsPending,
  pendingMs: 0,
  pendingMinMs: 0,
});

function AnalyticsMoveCertificationsRoute() {
  return <AnalyticsMoveReportPage activeTab={ANALYTICS_MOVE_TAB_CERTIFICATIONS} />;
}

function AnalyticsMoveCertificationsPending() {
  return (
    <Stack gap="md" data-testid="analytics-certifications-pending">
      <Skeleton className="h-10 w-72" />
      <Skeleton className="h-10 w-full" />
      <div className="space-y-3">
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton key={`certifications-pending-${String(index)}`} className="h-40 w-full" />
        ))}
      </div>
    </Stack>
  );
}
